var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C10.8956 13 10 13.8956 10 15C10 16.1044 10.8956 17 12 17C13.1044 17 14 16.1044 14 15C14 13.8956 13.1044 13 12 13ZM12 16C11.4492 16 11 15.5518 11 15C11 14.4483 11.4492 14 12 14C12.5508 14 13 14.4483 13 15C13 15.5518 12.5508 16 12 16ZM8 11C8 9.89564 7.10339 9 6 9C4.89454 9 4 9.89564 4 11C4 12.1044 4.89454 13 6 13C7.10364 13 8 12.1044 8 11ZM5 11C5 10.4483 5.44921 10 6 10C6.55079 10 7 10.4483 7 11C7 11.5518 6.55079 12 6 12C5.44921 12 5 11.5518 5 11ZM9 1C9 1 1 6 1 13C1 17.4179 4.58214 21 9 21C13.4179 21 17 17.4179 17 13C17 6 9 1 9 1ZM9 20C5.14071 20 2 16.8594 2 13C2 7.65036 7.285 3.43679 9.00107 2.21C10.7169 3.43364 16 7.63571 16 13C16 16.8593 12.8594 20 9 20ZM12.3536 10.3536L6.35364 16.3536L5.64661 15.6465L11.6466 9.64654L12.3536 10.3536Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.c1c3d2e4f29d75a672d6872957522a43.svg";
export { ForwardRef as ReactComponent };